import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CTASection = () => {
  const navigate = useNavigate();

  return (
    <section className="py-20 px-6 bg-gradient-to-br from-primary via-secondary to-primary">
      <div className="max-w-4xl mx-auto text-center">
        <div className="space-y-8">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-white rounded-2xl shadow-2xl mb-4">
            <Icon name="Zap" size={40} color="var(--color-primary)" />
          </div>

          <h2 className="text-3xl md:text-5xl font-bold text-white leading-tight">
            Únete a la Revolución del<br />
            Descuento Digital en Colombia
          </h2>

          <p className="text-xl text-white/90 max-w-2xl mx-auto">
            Miles de usuarios ya están ahorrando y ganando con BIZZNET. Es tu turno de formar parte de la comunidad comercial más innovadora.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center pt-4">
            <Button
              variant="default"
              size="lg"
              iconName="User"
              iconPosition="left"
              onClick={() => navigate('/user-registration')}
              className="bg-white text-primary hover:bg-white/90 min-w-[220px]"
            >
              Registro Usuario
            </Button>
            <Button
              variant="outline"
              size="lg"
              iconName="Briefcase"
              iconPosition="left"
              onClick={() => navigate('/business-registration')}
              className="border-2 border-white text-white hover:bg-white/10 min-w-[220px]"
            >
              Registro Empresa
            </Button>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 pt-8">
            <div className="flex flex-col items-center gap-2 text-white">
              <Icon name="Shield" size={32} />
              <span className="text-sm font-medium">100% Seguro</span>
            </div>
            <div className="flex flex-col items-center gap-2 text-white">
              <Icon name="Clock" size={32} />
              <span className="text-sm font-medium">Registro en 5 minutos</span>
            </div>
            <div className="flex flex-col items-center gap-2 text-white">
              <Icon name="HeadphonesIcon" size={32} />
              <span className="text-sm font-medium">Soporte 24/7</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;